import * as React from 'react';
import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';

import { Body } from '@funnels/ui-components';
import { getAriaLabelById, partialPIIMask } from '@funnels/utils';

import { LabelWrapper } from './index.style';

const AsteriskWrapper = styled.span`
  color: ${() => getColour('error', 500)};
`;

export interface FieldLabelWrapperProps {
  label?: string;
  labelAfter?: React.ReactNode;
  subLabel?: string;
  idPostfix?: string | number;
  piiStringInLabel?: string;
  isOptional?: boolean;
}

export const FieldLabel = (props: FieldLabelWrapperProps) => {
  const { label, labelAfter, subLabel, idPostfix, piiStringInLabel, isOptional = false } = props;

  if (label) {
    const displayLabel = piiStringInLabel ? partialPIIMask(label, piiStringInLabel) : label;
    return (
      <LabelWrapper data-testid="field-label-wrapper">
        <Body id={getAriaLabelById('label', idPostfix)} align="left" data-testid="field-label">
          {!isOptional && <AsteriskWrapper>* </AsteriskWrapper>}
          {displayLabel}
        </Body>
        {labelAfter}
        {subLabel && (
          <Body
            id={getAriaLabelById('description', idPostfix)}
            style={{ width: '100%' }}
            size={'xs'}
            color={getColour('text', 'subtle')}
          >
            {subLabel}
          </Body>
        )}
      </LabelWrapper>
    );
  }

  return null;
};
